"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Point_1 = require("../../../Utility/Point");
class RectangleUtil {
    static calculateTopPosition(align, rectContainer, rectRelativeTo) {
        switch (align) {
            case 'T':
                return rectRelativeTo.top - rectContainer.height;
            case 't':
                return rectRelativeTo.top - (rectContainer.height - rectRelativeTo.height);
            case 'b':
                return rectRelativeTo.top;
            case 'B':
                return rectRelativeTo.top + rectRelativeTo.height;
            case 'c':
            default:
                return rectRelativeTo.top - (rectContainer.height - rectRelativeTo.height) / 2;
        }
    }
    static calculateLeftPosition(align, rectContainer, rectRelativeTo) {
        switch (align) {
            case 'L':
                return rectRelativeTo.left - rectContainer.width;
            case 'l':
                return rectRelativeTo.left - rectContainer.width + rectRelativeTo.width;
            case 'r':
                return rectRelativeTo.left;
            case 'R':
                return rectRelativeTo.left + rectRelativeTo.width;
            case 'm':
            default:
                return rectRelativeTo.left - (rectContainer.width - rectRelativeTo.width) / 2;
        }
    }
    /**
     * Calculate the top left position based on the alignment, offset and rectangles
     * @param align the alignment indicator how to align the point
     * @param offset x + y modifier to add to the point
     * @param rectContainer the rectangle of the element being positioned
     * @param rectRelativeTo the rectangle where the position is determined around
     */
    static calculatePosition(align, offset, rectContainer, rectRelativeTo) {
        let y = RectangleUtil.calculateTopPosition(align.charAt(0), rectContainer, rectRelativeTo);
        let x = RectangleUtil.calculateLeftPosition(align.charAt(1), rectContainer, rectRelativeTo);
        // adjust point with given offset
        const alignedOffset = offset[align];
        if (alignedOffset !== undefined) {
            x += alignedOffset.x;
            y += alignedOffset.y;
        }
        else if (offset.x && offset.y) {
            x += offset.x;
            y += offset.y;
        }
        return new Point_1.default(rectContainer.left + x, rectContainer.top + y);
    }
}
exports.default = RectangleUtil;
//# sourceMappingURL=RectangleUtil.js.map